import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FrostMenuManagerService } from './frost-menu-manager.service';

@NgModule({
  imports: [CommonModule],
  providers: [FrostMenuManagerService]
})
export class FrostMenuManagerModule {} 